module.exports = __webpack_public_path__ + "img/twitter-x.d850a395.png";